import { render, staticRenderFns } from "./newChart.vue?vue&type=template&id=789e2316&scoped=true"
import script from "./newChart.vue?vue&type=script&lang=js"
export * from "./newChart.vue?vue&type=script&lang=js"
import style0 from "./newChart.vue?vue&type=style&index=0&id=789e2316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e2316",
  null
  
)

export default component.exports